var parseTime = function (schedule, which) {
    var value = which === 'start' ? schedule.getStartTimeAsDayjs() : schedule.getEndTimeAsDayjs();
    return value !== null && value !== void 0 ? value : null;
};
export var getScheduleDuration = function (schedule) {
    var start = parseTime(schedule, 'start');
    var end = parseTime(schedule, 'end');
    if (!start || !end) {
        return { minutes: 0, hours: 0, remMinutes: 0 };
    }
    var minutes = end.diff(start, 'minute');
    if (minutes < 0) {
        minutes += 24 * 60;
    }
    return {
        minutes: minutes,
        hours: Math.floor(minutes / 60),
        remMinutes: minutes % 60
    };
};
export var formatDurationChip = function (duration, labels) {
    if (duration.minutes <= 0)
        return '';
    if (duration.hours <= 0) {
        return labels.minutes.replace('{{minutes}}', String(duration.minutes));
    }
    if (duration.remMinutes === 0) {
        return labels.hours.replace('{{hours}}', String(duration.hours));
    }
    return labels.hoursMinutes
        .replace('{{hours}}', String(duration.hours))
        .replace('{{rem}}', String(duration.remMinutes));
};
export var formatScheduleClock = function (schedule, which) {
    var value = parseTime(schedule, which);
    return value ? value.format('HH:mm') : '—';
};
export var computeDoctorScheduleStats = function (schedules) {
    var active = schedules.filter(function (s) { return s.isActive(); });
    var source = active.length > 0 ? active : schedules;
    var totalMax = 0;
    var totalOnline = 0;
    var clinicalMinutes = 0;
    var clinicCounts = new Map();
    source.forEach(function (schedule) {
        var _a, _b, _c;
        var max = Math.max(0, schedule.getMaxAppointments());
        var online = Math.min(max, Math.max(0, schedule.getMaxOnlineAppointments()));
        totalMax += max;
        totalOnline += online;
        clinicalMinutes += getScheduleDuration(schedule).minutes;
        var clinicName = (_b = (_a = schedule.getClinic()) === null || _a === void 0 ? void 0 : _a.getName()) === null || _b === void 0 ? void 0 : _b.trim();
        if (clinicName) {
            clinicCounts.set(clinicName, ((_c = clinicCounts.get(clinicName)) !== null && _c !== void 0 ? _c : 0) + 1);
        }
    });
    var inClinic = Math.max(0, totalMax - totalOnline);
    var onlinePct = totalMax > 0 ? Math.round((totalOnline / totalMax) * 100) : 0;
    var clinicalHours = clinicalMinutes / 60;
    var clinicalHoursLabel = clinicalMinutes <= 0
        ? '0'
        : Number.isInteger(clinicalHours)
            ? String(clinicalHours)
            : clinicalHours.toFixed(1).replace(/\.0$/, '');
    var primaryClinic = '—';
    var top = 0;
    clinicCounts.forEach(function (count, name) {
        if (count > top) {
            top = count;
            primaryClinic = name;
        }
    });
    var roomHint = source
        .map(function (s) { var _a, _b; return (_b = (_a = s.getClinicRoom()) === null || _a === void 0 ? void 0 : _a.getName()) === null || _b === void 0 ? void 0 : _b.trim(); })
        .find(function (name) { return Boolean(name); }) || '';
    return {
        activeCount: active.length,
        totalMax: totalMax,
        totalOnline: totalOnline,
        inClinic: inClinic,
        onlinePct: onlinePct,
        clinicalMinutes: clinicalMinutes,
        clinicalHoursLabel: clinicalHoursLabel,
        primaryClinic: primaryClinic,
        primaryClinicHint: roomHint
    };
};
